import styled from "styled-components";

export const Container = styled.div`
  padding: 1rem;
`;

export const ExampleText = styled.span`
  font-size: 1.4rem;
  display: block;
`;

export const TextArea = styled.textarea`
  width: 100%;
  height: 150px;
  margin-bottom: 1rem;
  padding: 0.8rem;
  margin-top: 0.8rem;
  border-radius: 6px;
  resize: none;
`;

export const LineCounter = styled.span`
  font-size: 1.2rem;
  display: block;
  text-align: right;
  margin-top: -0.6rem;
  margin-bottom: 1rem;
`;

export const ProductListWrapper = styled.div`
  margin-top: 2rem;
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
  margin-bottom: 3rem;
`;

export const ProductListItemRow = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: stretch;
  gap: 0.8rem;
  margin-bottom: 0.8rem;
`;

export const RemoveProductButton = styled.button`
  all: unset;
  cursor: pointer;
  padding: 0 0.6rem;
  border: 1px solid #ee4b2b;
  border-radius: 4px;
  font-size: 1.3rem;
  font-weight: 600;
  color: #ee4b2b;
  text-transform: uppercase;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background-color: #ee4b2b;
    color: #ffffff;
  }
`;
